import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex) // 安装插件

export default new Vuex.Store({ // 实例化Vuex仓库
  state: {
    num: 0,
    students: [
      {sno: 1, sname: 'yangzhu', age: 48},
      {sno: 2, sname: 'zhangsan', age: 22},
      {sno: 3, sname: 'lisi', age: 18}
    ]
  },
  mutations: {
    addnum (state, numb) {
      state.num += numb || 1
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js